import api from '@/api/siteMessage'

const state = {

}

const actions = {
  getSiteMessageList (context, params) {
    return api.getSiteMessageList(params)
  },
  getSiteMessageInfoByMessageId (context, params) {
    return api.getSiteMessageInfoByMessageId(params)
  },
  createSiteMessage (context, params) {
    return api.createSiteMessage(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
